import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { SettingsService } from '@toro/common/shared/services/settings/settings.service';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { ILoggedHomeAppState } from '@hub-workspace/apps/logged-home/src/app/shared/interfaces/logged-home-app-state.interface';
import { STVMDigitalAction } from '@hub-workspace/apps/logged-home/src/app/state-management/stvm-digital/stvm-digital.action';
import { UserReRegistationService } from '@toro/common/shared/services/re-registration/user-re-registration.service';
import { IReRegistrationMessage } from '@toro/common/shared/interfaces/re-registration/re-resgistration.interface';
import { ModalComponent } from '@toro/common/shared/components/modal/modal.component';
import { StorageService } from '../../../../../../../../libs/common/shared/services/storage.service';
import { combineLatest } from 'rxjs';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'home-trader',
  templateUrl: './home-trader.component.html',
})
export class HomeTraderComponent implements OnInit {
  @ViewChild('modalUserRegister', { static: true })
  public modalUserRegister: ModalComponent;

  @Input() homeStatus: 'open' | 'active';

  public modalUserReRegistration: IReRegistrationMessage;

  constructor(
    private store: Store<ILoggedHomeAppState>,
    private settingService: SettingsService,
    private userReRegistationService: UserReRegistationService,
  ) {
    this.store.dispatch({ type: STVMDigitalAction.getPortabilities });
  }

  public ngOnInit() {
    this.getUserDataAndTrack();
  }

  private getUserDataAndTrack() {
    combineLatest([
      this.store.select(({ userProfile }) => userProfile),
      this.store.select((state: any) => state.operationalLimit),
    ])
      .pipe(
        filter(([up, op]) => !!up.user && op && !op.pending),
        take(1),
      )
      .subscribe(([up, op]) => {
        this.trackPageLoad(up, op);

        if (up.user.registrationStatus) {
          this.verifyUserReRegister(+up.user.registrationStatus);
        }
      });
  }

  private trackPageLoad(up: any, op: any) {
    const status = this.homeStatus || up.user?.homeStatus;
    const accepted = op?.value?.isAccepted === true;

    let santanderLimit = 'ativo';

    if (
      !accepted &&
      (status === 'open' || status === 'active' || status === undefined)
    ) {
      santanderLimit = 'inativo';
    }

    const cookieExclusiveStatus = StorageService.getCookie(
      'hubUserExclusiveStatus',
    );
    const isExclusive = cookieExclusiveStatus === 'true';

    const scenario = isExclusive ? 'Cliente Exclusivo' : 'Cliente Varejo';

    this.sendTracking('Page Loaded', {
      'Product Area Origin': 'Home Trader',
      Status: 'Conta ativa',
      Scenario: scenario,
      'Time Responsável': 'Sky',
      'Specific Properties': {
        'Santander Operational Limit': santanderLimit,
      }
    });
  }

  public sendTracking(event: string, breakdowns: any) {
    this.store.dispatch({
      type: TrackingActions.trackEvents,
      payload: { type: event, events: breakdowns },
    });
  }

  /**
   * verifica se usuário esta expirado
   * Expired = 15
   * PreExpirado = 18
   */

  private verifyUserReRegister(registrationStatus: number) {
    const userExpired =
      this.userReRegistationService.validateUserExpired(registrationStatus);
    if (!!userExpired) {
      this.modalUserReRegistration = userExpired;
      this.modalUserRegister.show();
      return;
    }

    const userPreExpired =
      this.userReRegistationService.validateUserPreExpired(registrationStatus);
    if (!!userPreExpired) {
      this.modalUserReRegistration = userPreExpired;
      this.modalUserRegister.show();
      return;
    }
  }
}
